import { useRouter } from 'react-resource-router';

import { useStatsigGate } from 'src/hooks/statsig';
import { useHistory__UNSAFE, useParams } from 'src/router/hooks';
import IframeWrapped from 'src/sections/repository/components/iframe-wrapped';

import SourceBrowser, { Params } from './source-browser';
import SourceSection from './source-section';

const SourceBrowserWrapped = () => {
  const [router] = useRouter();
  const history = useHistory__UNSAFE();
  const params = useParams<Params>();
  const isSourceEditorEnabled = useStatsigGate('bbc-frontbucket-source-editor');

  if (router.query.mode === 'edit' && !isSourceEditorEnabled) {
    return <IframeWrapped />;
  }

  return (
    <SourceSection {...router} {...params} history={history}>
      <SourceBrowser {...router} {...params} history={history} />
    </SourceSection>
  );
};

export default SourceBrowserWrapped;
